import {
  binCountSessionIdFormat,
  storageLocationIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod/v4";

const BinStatus = z.object({
  storageLocationId: storageLocationIdFormat.schema,
  binName: z.string(),
  countedAt: z.date().nullable(),
  deletedAt: z.date().nullable(),
});

export const getBinCountSession = {
  name: "getBinCountSession" as const,
  input: z.object({ binCountSessionId: binCountSessionIdFormat.schema }),
  output: z.object({
    binCountSessionId: binCountSessionIdFormat.schema,
    bins: z.array(BinStatus),
    completedAt: z.date().nullable(),
    deletedAt: z.date().nullable(),
    createdAt: z.date(),
  }),
};
